module.exports = __webpack_public_path__ + "static/img/2areaA_21.500934e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_21.png
// module id = 891
// module chunks = 1